export default function isOptionEnabled(option) {
  return option.disabled ? option.disabled == false : true;
}
